import { appLocalStorage } from './storage';
import config from './config';
import { discardAuthAttempts } from './authAttemptStorage';
import { isDeletedOwner } from '../accountDeletion/ownerState';

export function getLanguage() {
    const language = (appLocalStorage.getItem('i18nextLng') || 'en').toLowerCase().split('-')[0];
    return language === 'en' || config.languages.includes(language) ? language : 'en';
}

export function getUser() {
    const saved = appLocalStorage.getItem(config.user);
    if (saved === null) return null;
    // A partial/corrupt cached profile must not crash every page before the
    // server has a chance to validate the token and replace the cache.
    try {
        const user = JSON.parse(saved);
        return user && !Array.isArray(user) && typeof user === 'object'
            && Number.isSafeInteger(user.id) && user.id > 0 ? user : null;
    } catch { return null; }
}

export function removeUser({ preserveAuthAttempts = false } = {}) {
  if (!preserveAuthAttempts) discardAuthAttempts();
  appLocalStorage.removeItem('user');
  appLocalStorage.removeItem(config.token);
  // Subscriptions belong to a session; do not leave a guest on that feed.
  if (appLocalStorage.getItem(config.area) === config.areaType.friends) {
    appLocalStorage.setItem(config.area, config.areaType.all);
  }
  window.dispatchEvent(new Event('wiw:session-changed'));
}

export function setLocalStorage(item, data) {
  appLocalStorage.setItem(item, data);
  if (item === config.token || item === config.user) window.dispatchEvent(new Event('wiw:session-changed'));
}

// Publish an account change only after both writes succeed. Subscribers must
// never issue requests with the new credential and the previous cached user.
// Keep the token last: on cold startup the server remains the source of truth
// for any profile write interrupted by process termination.
export function installSession(token, user) {
  if (typeof token !== 'string' || !token.trim() || !Number.isSafeInteger(user?.id) || user.id <= 0) {
    throw new Error('Sign-in failed');
  }
  if (isDeletedOwner(user.id)) throw new Error('ACCOUNT_DELETED');
  const entries = [[config.user, JSON.stringify(user)], [config.token, token]];
  const previous = entries.map(([key]) => [key, appLocalStorage.getItem(key)]);
  try {
    discardAuthAttempts();
    entries.forEach(([key, value]) => appLocalStorage.setItem(key, value));
  } catch (error) {
    previous.forEach(([key, value]) => {
      try {
        if (value === null) appLocalStorage.removeItem(key);
        else appLocalStorage.setItem(key, value);
      } catch { /* Preserve the original storage failure. */ }
    });
    throw error;
  }
  window.dispatchEvent(new Event('wiw:session-changed'));
}

export function getLocalStorage(item) {
  return appLocalStorage.getItem(item);
}

/**
 * 
 * @returns флаг приватности для добавляемых реакций
 */
export function getPrivatFlg() {
  const privat_flg = (appLocalStorage.getItem(config.privat)) ? (appLocalStorage.getItem(config.privat) === "true") : false;
  return privat_flg;
}

export function createName (author) {
    let name  = '';
    if (!author) return name;
    if (!!author.first_name) name+=author.first_name;
    if (name!=='') name+=' ';
    if (!!author.last_name) name+=author.last_name;
    return name;
}

export function generateFToken() {
    var d = new Date().getTime();
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        // eslint-disable-next-line no-mixed-operators
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export { handleImageUpload } from './imageUpload';

export function formatNumberIntl(value) {
  return new Intl.NumberFormat(getLanguage()).format(value);
}
